import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';

const SUBLOCATION_NAV_STICKY_OFFSET = 36;

const useStyles = makeStyles((theme) => ({
  reconciliationAccordion: {
    '& .MuiTableContainer-root': {
      overflowX: 'hidden',
    },
    '& .MuiTableCell-root': {
      padding: '8px 10px !important',
      verticalAlign: 'middle',
      borderColor: `${theme.palette.grey[500]} !important`,
    },
    '& .MuiTableHead-root .MuiTableCell-root': {
      fontSize: 11,
      fontWeight: 700,
      lineHeight: 1.1,
      whiteSpace: 'nowrap',
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
      fontSize: 13,
      lineHeight: 1.2,
      borderTop: 'none !important',
      borderBottom: 'none !important',
    },
    '& tbody tr': {
      borderTop: 'none !important',
    },
    '& .MuiTableBody-root > .MuiTableRow-root:not([class*=makeStyles-accordionBody]) .MuiTableCell-root': {
      fontSize: 15,
      lineHeight: 1.35,
      verticalAlign: 'middle',
      borderBottom: 'none !important',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      minHeight: 44,
      fontSize: 14,
    },
    '& .MuiOutlinedInput-input': {
      padding: '11px 10px !important',
      fontSize: 14,
      lineHeight: 1.2,
    },
    '& .MuiInputAdornment-root': {
      marginRight: 4,
      '& .MuiTypography-root, & .MuiSvgIcon-root': {
        fontSize: 12,
      },
    },
    '& .MuiFormLabel-root.MuiInputLabel-root': {
      whiteSpace: 'nowrap',
      lineHeight: 1,
      fontSize: 11,
      transform: 'translate(14px, 8px) scale(1)',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    '& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-shrink': {
      transform: 'translate(14px, -5px) scale(0.75)',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
    '& tr[class*=makeStyles-accordionBody]': {
      '& td': {
        verticalAlign: 'top',
      },
      '& td:first-of-type': {
        padding: '8px 10px 0 10px !important',
      },
    },
  },
  openCollectionAccordion: {
    '& .MuiTableContainer-root': {
      overflowX: 'hidden',
    },
    '& .MuiTableCell-root': {
      padding: '8px 10px !important',
      verticalAlign: 'middle',
      borderColor: `${theme.palette.grey[500]} !important`,
    },
    '& .MuiTableHead-root .MuiTableCell-root': {
      fontSize: 11,
      fontWeight: 700,
      lineHeight: 1.1,
      whiteSpace: 'nowrap',
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
      fontSize: 13,
      lineHeight: 1.2,
      borderTop: 'none !important',
      borderBottom: 'none !important',
    },
    '& tbody tr': {
      borderTop: 'none !important',
    },
    '& .MuiTableBody-root > .MuiTableRow-root:not([class*=makeStyles-accordionBody]) .MuiTableCell-root': {
      fontSize: 15,
      lineHeight: 1.35,
      verticalAlign: 'middle',
      borderBottom: 'none !important',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      minHeight: 44,
      fontSize: 14,
    },
    '& .MuiOutlinedInput-input': {
      padding: '11px 10px !important',
      fontSize: 14,
      lineHeight: 1.2,
    },
    '& .MuiInputAdornment-root': {
      marginRight: 4,
      '& .MuiTypography-root, & .MuiSvgIcon-root': {
        fontSize: 12,
      },
    },
    '& .MuiFormLabel-root.MuiInputLabel-root': {
      whiteSpace: 'nowrap',
      lineHeight: 1,
      fontSize: 11,
      transform: 'translate(14px, 8px) scale(1)',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    '& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-shrink': {
      transform: 'translate(14px, -5px) scale(0.75)',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
  },
  accountSummaryFields: {
    minHeight: '32px',
    marginTop: 0,
    borderRadius: 0,
    fontSize: '12px',
    '& .MuiAutocomplete-root': { minHeight: '32px' },
    '& .MuiOutlinedInput-notchedOutline': { borderRadius: 0 },
    '& .MuiGrid2-root': { height: '100%', padding: 0 },
    '& .MuiFormControl-root': { height: '100%' },
    '& .MuiInputBase-root': {
      height: '100%',
      minHeight: '32px',
      fontSize: 13,
      borderRadius: 0,
    },
    '& .MuiTextField-root': {
      '& .MuiOutlinedInput-input': { height: '100%', padding: '6px 8px', borderRadius: 0, fontSize: 13 },
    },
    '& .MuiAutocomplete-root .MuiOutlinedInput-root': {
      minHeight: '32px',
      borderRadius: 0,
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
    },
    '& .MuiAutocomplete-root .MuiOutlinedInput-input': {
      padding: '6px 8px !important',
      fontSize: 13,
    },
    '& .MuiButtonBase-root MuiMenuItem-root': { fontSize: 'small' },
  },
  accountSummaryTitleFields: { '& .MuiTypography-root': { fontSize: '15px' }, padding: '8px 24px 0px 24px' },
  addNewRowBtn: { fontSize: 'small', padding: '6px 0px 0px 24px', '&:hover': { background: 'white' } },
  accountSummaryTitleContainer: {
    backgroundColor: theme.palette.grey[900_2],
    padding: '8px 10px',
  },
  accountSummaryInfoCurrencyText: {
    fontSize: 'small',
    fontWeight: 'bold',
    '& .MuiTypography-root': { fontSize: 'small' },
  },
  collectionFieldItem: {
    '& .Mui-disabled': {
      '&.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.error.main,
        },
      },
    },
  },
  datePointerEvent: {
    pointerEvents: 'auto',
    backgroundColor: theme.palette?.common?.white,
    borderRadius: 8,
    minWidth: 190,
    '& .MuiFormControl-root, & .MuiTextField-root': {
      width: '100%',
      minWidth: 190,
    },
    '& .MuiInputBase-input': {
      minWidth: 0,
    },
  },
  dateContainer: {
    verticalAlign: 'middle',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    lineHeight: '20px',
    gap: '4px 0',
    '& .MuiInputBase-root': { height: '45px', fontSize: '14px' },
  },
  debitCreditField: {
    '& .MuiTextField-root': {
      '& .MuiOutlinedInput-input': { height: '100%', padding: 0, borderRadius: 0 },
    },
  },
  labelClass: {
    '& .MuiFormLabel-root.MuiInputLabel-root': {
      marginTop: '-4px',
    },
  },
  compactMetersContainer: {
    gap: 0,
  },
  compactMeterRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 6,
    width: '100%',
    minWidth: 0,
  },
  compactMeterLabelWrap: {
    flex: '0 0 160px',
    minWidth: 160,
    paddingTop: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  compactMeterLabel: {
    fontSize: '0.82rem',
    lineHeight: 1.2,
    fontWeight: 600,
    wordBreak: 'break-word',
  },
  compactMeterGrid: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    gap: 1,
  },
  compactFieldCell: {
    maxWidth: 'none !important',
    minWidth: 95,
    width: '100%',
  },
  compactFieldCellPlaceholder: {
    maxWidth: 'none !important',
    minWidth: 120,
    width: '100%',
    '& .MuiInputBase-root, & .MuiFormControl-root, & .MuiTextField-root': {
      display: 'none',
    },
  },
  reconciliationContentLayout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    width: '100%',
  },
  reconciliationGridSection: {
    flex: 1,
    minWidth: 0,
  },
  reconciliationSummaryPanel: {
    position: 'sticky',
    top: 84,
    width: 300,
    minWidth: 300,
    alignSelf: 'flex-start',
    background: theme.palette.common.white,
    border: 'none',
    padding: '8px',
  },
  reconciliationSummaryActionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 8,
    gap: 8,
  },
  summaryAndRepRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 10,
    width: '100%',
    marginTop: 2,
  },
  summaryAndRepPrimary: {
    flex: '1 1 78%',
    minWidth: 0,
  },
  summaryAndRepSecondary: {
    flex: '1 1 22%',
    minWidth: 240,
    background: theme.palette.grey[200],
  },
  [theme.breakpoints.down('lg')]: {
    compactMeterLabelWrap: {
      flex: '0 0 130px',
      minWidth: 130,
    },
    compactFieldCell: {
      minWidth: 90,
    },
    reconciliationSummaryPanel: {
      width: 180,
      minWidth: 180,
      maxWidth: 180,
    },
    summaryAndRepSecondary: {
      minWidth: 220,
    },
  },
  [theme.breakpoints.down('md')]: {
    compactMeterRow: {
      flexDirection: 'column',
      gap: 3,
    },
    compactMeterLabelWrap: {
      flex: '1 1 auto',
      minWidth: 0,
    },
    compactMeterGrid: {
      flexWrap: 'wrap',
      gap: 2,
    },
    compactFieldCell: {
      minWidth: 120,
    },
    reconciliationContentLayout: {
      flexDirection: 'column',
      gap: 8,
    },
    reconciliationSummaryPanel: {
      position: 'static',
      width: '100%',
      minWidth: 0,
    },
    summaryAndRepRow: {
      flexDirection: 'column',
      gap: 10,
    },
    summaryAndRepSecondary: {
      minWidth: 0,
    },
  },
  reportModalClass: {
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
    },
  },
  reportIssueReason: {
    textTransform: 'capitalize',
  },
  draftedLocationName: {
    display: 'flex',
    alignItems: 'center',
  },
  calculateRowBtnContainer: {
    justifyContent: 'end',
    padding: '4px 8px 0px 0px',
  },
  historyButton: {
    marginRight: '10px',
  },
  editContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '20px',
    gap: '20px',
  },
  historyButtonsContainer: {
    display: 'flex',
    gap: '40px',
    justifyContent: 'center',
  },
  historyGridContainer: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  UpdatedByTimeContainerItems: {
    display: 'flex',
    justifyContent: 'center',
    marginRight: '20px',
  },
  sublocationNavigatorFab: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 1200,
  },
  sublocationNavigatorPopover: {
    maxHeight: '50vh',
    overflowY: 'auto',
    width: 500,
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
    borderRadius: 8,
    marginBottom: 4,
    '& .MuiListItemButton-root:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.06),
      color: theme.palette.common.black,
    },
    '& .MuiListItemButton-root:hover .MuiListItemText-primary, & .MuiListItemButton-root:hover .MuiListItemText-secondary, & .MuiListItemButton-root:hover .MuiListItemIcon-root, & .MuiListItemButton-root:hover .MuiIconButton-root':
      {
        color: theme.palette.common.black,
      },
  },
  sublocationNavWarningIcon: {
    marginLeft: theme.spacing(1),
  },
  sublocationNavIcon: {
    minWidth: 32,
    color: 'inherit',
  },
  sublocationNavExpandBtn: {
    marginLeft: theme.spacing(0.5),
    color: 'inherit',
  },
  sublocationNavAction: {
    backgroundColor: theme.palette.grey[900_2],
    color: theme.palette.common.black,
    minHeight: SUBLOCATION_NAV_STICKY_OFFSET,
    paddingTop: 0,
    paddingBottom: 0,
    boxSizing: 'border-box',
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: '0.8rem',
      color: 'inherit',
    },
    '&:hover': {
      backgroundColor: `${theme.palette.grey[900_2]} !important`,
      color: `${theme.palette.common.black} !important`,
    },
  },
  sublocationNavStickyTop: {
    position: 'sticky',
    top: 0,
    zIndex: 4,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  },
  sublocationNavStickyBottom: {
    position: 'sticky',
    bottom: 0,
    zIndex: 4,
    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.08)',
  },
  sublocationNavItem: {
    backgroundColor: theme.palette.grey[900_2],
    color: theme.palette.common.black,
    boxShadow: `inset 0 -1px 0 ${alpha(theme.palette.common.black, 0.12)}`,
    transition: 'background-color 140ms ease, box-shadow 140ms ease',
    '& .MuiListItemText-primary, & .MuiListItemText-secondary, & .MuiListItemIcon-root, & .MuiIconButton-root': {
      color: 'inherit',
    },
    '&:hover': {
      backgroundColor: `${theme.palette.grey[900_2]} !important`,
      color: `${theme.palette.common.black} !important`,
    },
  },
  sublocationNavSection: {
    position: 'sticky',
    top: SUBLOCATION_NAV_STICKY_OFFSET,
    zIndex: 1,
    backgroundColor: theme.palette.grey[900_2],
  },
  sublocationNavActive: {
    backgroundColor: theme.palette.grey[900_2],
    color: theme.palette.common.black,
    boxShadow: `inset 3px 0 0 ${theme.palette.primary.main}, inset 0 -1px 0 ${alpha(theme.palette.common.black, 0.12)}`,
    '&:hover': {
      backgroundColor: theme.palette.grey[900_2],
      color: theme.palette.common.black,
    },
    '& .MuiListItemText-primary': {
      fontWeight: 600,
    },
  },
  sublocationNavAsset: {
    paddingLeft: theme.spacing(6),
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: `inset 0 -1px 0 ${alpha(theme.palette.common.black, 0.12)}`,
    transition: 'background-color 140ms ease, box-shadow 140ms ease',
    '& .MuiListItemText-primary': {
      fontSize: '0.78rem',
      color: 'inherit',
    },
    '& .MuiListItemText-secondary': {
      fontSize: '0.7rem',
      color: 'inherit',
    },
  },
  sublocationNavAssetActive: {
    backgroundColor: theme.palette.grey[900_2],
    color: theme.palette.common.black,
    boxShadow: `inset 3px 0 0 ${theme.palette.primary.main}, inset 0 -1px 0 ${alpha(theme.palette.common.black, 0.12)}`,
    '& .MuiListItemText-primary': {
      fontWeight: 600,
    },
    '& .MuiListItemText-primary, & .MuiListItemText-secondary, & .MuiListItemIcon-root': {
      color: 'inherit',
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[900_2],
      color: theme.palette.common.black,
    },
  },
  sublocationNavAssetText: {
    margin: 0,
  },
}));

export default useStyles;
